import Contact, { getStaticProps as getStaticContactProps } from '../components/pages/Contact';

export default Contact;

export const getStaticProps = getStaticContactProps;
